import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

import {forgotPassword} from 'actions/userActions';

import validationHelper from 'helpers/validationHelper';
import uiHelper from 'helpers/uiHelper';

import TextInput from 'components/common/TextInput';
import AuthContainer from './components/AuthContainer';
import AuthBackgroundImage from './components/AuthBackgroundImage';
import AuthBodyContainer from './components/AuthBodyContainer';
import AuthTitle from './components/AuthTitle';
import AuthLink from './components/AuthLink';
import SubmitButton from './components/SubmitButton';

function PasswordForgotPage() {
  const dispatch = useDispatch();

  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({email: ''});

  function onChange(field: string, value: string) {
    setEmail(value);
  }

  function forgotFormIsValid() {
    let newErrors = {email: ''};

    if (!email) {
      newErrors.email = 'Email field is required.';
    } else if (!validationHelper.isValidEmail(email)) {
      newErrors.email = 'Email is not valid.';
    }

    setErrors(newErrors);

    return validationHelper.isEmptyErrorObject(newErrors);
  }

  async function resetPassword(e) {
    if (e) e.preventDefault();

    if (!isActiveButton()) return;

    if (!forgotFormIsValid()) return;

    let response: any = await dispatch(forgotPassword(email));

    if (response && response.success) {
      uiHelper.showMessage(`We've just dropped you an email. Please check your mail to reset your password. Thanks!`);
    }
  }

  function isActiveButton() {
    return email ? true : false;
  }

  function render() {
    let isActive = isActiveButton();

    return (
      <AuthContainer>
        <AuthBackgroundImage />

        <AuthBodyContainer isSignUp={false}>
          <AuthTitle>Reset Password</AuthTitle>

          <form>
            <TextInput
              name="email"
              type="email"
              value={email}
              onChange={onChange}
              placeholder="Email"
              error={errors.email}
            />

            <SubmitButton isActive={isActive} title="Reset Password" onSubmit={resetPassword} />
          </form>

          <AuthLink url="/login" title="Already have an account?" linkText="Login" />
        </AuthBodyContainer>
      </AuthContainer>
    );
  }

  return render();
}

export default PasswordForgotPage;
